<template>
  <RevInfoBlock
    class="w-auto"
    :icon="IconInfo"
    :title="i18n(translations.howDoesItWork)"
    variant="default"
  >
    <ol class="mt-2">
      <li>{{ i18n(translations.firstPoint) }}</li>
      <li>{{ i18n(translations.secondPoint) }}</li>
      <li>{{ i18n(translations.thirdPoint) }}</li>
      <li>
        <RevLink
          :to="{
            name: ROUTE_NAMES.LISTINGS.TABS.ACTIVE,
            query: { 'listing-action': 'import' },
          }"
        >
          {{ i18n(translations.forthPoint) }}
        </RevLink>
      </li>
    </ol>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconInfo } from '@ds/icons/IconInfo'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './Help.translations'

const i18n = useI18n()
</script>
